<template>
  <label class="ui-btn ui-btn--sm rd-toggle" :class="{ 'is-on': checked }">
    <input v-model="checked" type="checkbox" class="rd-visually-hidden" />
    <v-icon size="16" :color="checked ? '#9a3412' : '#5f5852'">
      {{ checked ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline" }}
    </v-icon>
    {{ $t("show_company_names_print") }}
  </label>
</template>

<script>
/** "Prikaži nazive firmi prilikom štampe": isti izbor (store report/filters.showCompanyNames) koji čitaju stari tabovi. */
export default {
  name: "ReportPrintNames",
  computed: {
    checked: {
      get() {
        return this.$store.state.report.filters.showCompanyNames;
      },
      set(value) {
        this.$store.commit("report/SET_FILTER", { key: "showCompanyNames", value });
      },
    },
  },
};
</script>
